"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const HelperUtils_1 = require("utils/HelperUtils");
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
require("./_card-label.scss");
function CardLabel({ iconLabel, title, isHover, onClickLabel = () => null, isTextPurple, dataCy, withSpace = true, maxWidthClass, truncate = false }) {
    const iconList = {
        weight: 'icon-weight',
        objective: 'icon-objective',
        history: 'icon-history',
        leader: 'icon-account_circle',
        member: 'icon-supervised_user_circle',
        team: 'icon-group-work',
        project: 'icon-dvr'
    };
    const cardLabelWrapperCN = (0, classnames_template_literals_1.default)(`
    card-label
    ${!isHover && withSpace && 'mr-[12px]'}
    px-[8px] py-[2px]
    rounded-[4px]
    ${(iconLabel === null || iconLabel === void 0 ? void 0 : iconLabel.includes('leader')) ? 'bg-base-200' : 'bg-n-300'}
  `);
    const cardLabelCN = (0, classnames_template_literals_1.default)(`
    label
    typography-h100
    ${isTextPurple ? 'text-base-600' : 'text-n-800'}
    ${maxWidthClass && maxWidthClass}
  `);
    const titleLabelCN = (0, classnames_template_literals_1.default)(`
    ${truncate ? 'truncate' : ''}
    ${(iconLabel === null || iconLabel === void 0 ? void 0 : iconLabel.includes('leader')) ? 'text-base-800' : 'text-n-800'}
    typography-h100
  `);
    const onClick = (e) => {
        e.stopPropagation();
        onClickLabel();
    };
    return (react_1.default.createElement("div", { className: cardLabelWrapperCN, onClick: onClick, "data-cy": dataCy },
        react_1.default.createElement("div", { className: cardLabelCN },
            react_1.default.createElement(SVGIcon_1.default, { iconName: iconLabel ? iconList[iconLabel] : '', fillColor: iconLabel === 'leader' ? 'var(--base-600)' : 'var(--n-600)', size: 16, customClass: "mr-[4px]" }),
            react_1.default.createElement("p", { className: titleLabelCN }, (0, HelperUtils_1.getObjectiveLocale)((0, HelperUtils_1.capitalize)(title)))),
        isHover && (react_1.default.createElement(SVGIcon_1.default, { iconName: "icon-pencil", size: 12, fillColor: "var(--n-600)", customClass: "mx-[4px]" }))));
}
exports.default = CardLabel;
